import axios from "axios";
import { API_BASE_URL } from "configs/AppConfig";
import { AUTH_TOKEN, TENANT_CODE_HEADER } from "store/auth/login/actionTypes";
import history from "../history";
// import { notification } from "antd";

const service = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000,
});

// Config
const ENTRY_ROUTE = "/login";
const TOKEN_PAYLOAD_KEY = "authorization";
const X_TENANT = "X-Tenant";
const PUBLIC_REQUEST_KEY = "public-request";
const ACCESS_CONTROL_ALLOW_ORIGIN = "access-control-allow-origin";

// API Request interceptor
service.interceptors.request.use(
  config => {
    var jwtToken = "";
    jwtToken =
      "Bearer " +
      "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJhYjg2YmIzYy0wODgzLTM2NzQtYjYwNC02YzQwM2JkM2EwOWEiLCJhdXRoIjoiUk9MRV9FSU5WT0lDRV9NSU5WT0lDRV9BRE1JTiIsInVzZXJJbmZvIjp7InVzZXJDb2RlIjoiZWludm9pY2UubWludm9pY2UuYWI4NmJiM2MtMDg4My0zNjc0LWI2MDQtNmM0MDNiZDNhMDlhIiwiZnVsbE5hbWUiOiJtaW52b2ljZV9kZXYiLCJmaXJzdExvZ2luVGltZSI6MTY0MDI1Mjg5MzAwMCwibGFzdExvZ2luVGltZSI6MTY0MDg3MzYzMTMxNSwidXNlck5hbWUiOiJhYjg2YmIzYy0wODgzLTM2NzQtYjYwNC02YzQwM2JkM2EwOWEiLCJ0ZW5hbnRDb2RlIjoiTUlOVk9JQ0UiLCJhcHBDb2RlIjoiRUlOVk9JQ0UifSwiY2xpZW50SW5mbyI6eyJjbGllbnRDb2RlIjoiYWI4NmJiM2MtMDg4My0zNjc0LWI2MDQtNmM0MDNiZDNhMDlhIiwiZW1haWwiOiJtaW52b2ljZV9kZXYxQG1pbnZvaWNlLnZuIiwiZnVsbE5hbWUiOiJtaW52b2ljZV9kZXYiLCJjbGllbnRUeXBlIjowLCJjb250YWN0RW1haWwiOiIiLCJwaG9uZU51bWJlciI6IiIsImNybVJlZiI6IiJ9LCJleHAiOjE5NjAwODE3ODd9.biHm6W4Q5OIxjrtNb8WkPKO7IanbvcpCxOT0lrXPDuQNfHqFviq7BDvqVe0dwhNelkduYwO7Qt0DEjhN8oQ-sw";
    if (jwtToken) {
      const tenantCode = localStorage.getItem(TENANT_CODE_HEADER);
      if (tenantCode) {
        config.headers[X_TENANT] = localStorage.getItem(TENANT_CODE_HEADER);
      }
      config.headers[TOKEN_PAYLOAD_KEY] = jwtToken;
    }
    if (!jwtToken && !config.headers[PUBLIC_REQUEST_KEY]) {
      history.push(ENTRY_ROUTE);
      window.location.reload();
    }

    return config;
  },
  error => {
    // Do something with request error here
    // notification.error({
    //   message: "Error",
    // });
    Promise.reject(error);
  }
);

// API respone interceptor
service.interceptors.response.use(
  response => {
    return response.data;
  },
  error => {
    let notificationParam = {
      message: "",
    };

    // Remove token and redirect
    if (
      error.response.status === 400
      // error.response.status === 403 ||
      // error.response.status === 401
    ) {
      notificationParam.message = "Authentication Fail";
      notificationParam.description = "Please login again";
      localStorage.removeItem(AUTH_TOKEN);
      history.push(ENTRY_ROUTE);
      window.location.reload();
    }

    if (error.response.status === 404) {
      notificationParam.message = "Not Found";
    }

    if (error.response.status === 500) {
      notificationParam.message = "Internal Server Error";
    }

    if (error.response.status === 508) {
      notificationParam.message = "Time Out";
    }

    // notification.error(notificationParam);

    return Promise.reject(error);
  }
);

export default service;
